/*
 * McCall's sashes (snippets/mccalls-sash.liquid). Shopify can serve a cached page after a sash's
 * end date, so this removes any sash outside its start/end window, and turns the second line of a
 * countdown sash into "Ends in 2d 4h" / "Ends in 3h 12m" / "Ends in 9m". Re-checks every 30 s, which
 * also catches cards added later by filters and infinite scroll.
 */
(function () {
  function left(ms) {
    var m = Math.max(0, Math.floor(ms / 60000));
    var d = Math.floor(m / 1440);
    var h = Math.floor((m % 1440) / 60);
    var mm = m % 60;
    if (d > 0) return 'Ends in ' + d + 'd ' + h + 'h';
    if (h > 0) return 'Ends in ' + h + 'h ' + mm + 'm';
    return 'Ends in ' + Math.max(1, mm) + 'm';
  }
  function tick() {
    var now = Date.now();
    var els = document.querySelectorAll('.mc-sash[data-sash-end], .mc-sash[data-sash-start]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = el.getAttribute('data-sash-end') ? Date.parse(el.getAttribute('data-sash-end')) : NaN;
      var start = el.getAttribute('data-sash-start') ? Date.parse(el.getAttribute('data-sash-start')) : NaN;
      if ((!isNaN(end) && now >= end) || (!isNaN(start) && now < start)) { el.remove(); continue; }
      if (el.hasAttribute('data-sash-countdown') && !isNaN(end)) {
        var l2 = el.querySelector('[data-sash-l2]');
        if (l2) l2.textContent = left(end - now);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
  setInterval(tick, 30000);
})();
